import axios from "axios"

import * as filesService from "@/services/files.js"

export const getExternalApplicants = () => axios.get("/api/main/users/getExternalApplicants")

export const doesUserNameExist = (userName) =>
  axios.get("/api/main/users/doesUserNameExist", {
    params: { userName }
  })

export const getCurrentUserFullInfo = () => axios.get("/api/main/users/getCurrentUserFullInfo")

export const getFullUserInfoForRelatedContact = () => axios.get("/api/main/users/getFullUserInfoForRelatedContact")

export const getConnectedUsers = () => axios.get("/api/main/users/getConnectedUsers")

export const deleteUserRequest = (data) => axios.post("/api/main/account/deleteUserRequest", data)

export const updateContactRequest = (data) => axios.post("/api/main/account/updateContactRequest", data)

let surveysShowForUserCached = null

export const getSurveysShowForUser = async () => {
  if (!surveysShowForUserCached) {
    surveysShowForUserCached = axios.get("/api/surveys/appSettings/showForUser")
  }

  return await surveysShowForUserCached
}

export const updateUserRequest = ({ representative, files }) =>
  axios.post("/api/main/account/updateUserRequest", filesService.prepareFormData({ files, fields: { representative: JSON.stringify(representative) } }), {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })

export const sendRegistrationRequest = ({ representative, files }) =>
  axios.post("/api/main/account/sendRegistrationRequest", filesService.prepareFormData({ files, fields: { representative: JSON.stringify(representative) } }), {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
